import { Avatar, Box, Grid, TextField, Typography, IconButton } from '@mui/material';
import { useTranslation } from 'react-i18next';
import SwitchComponent from '../../components/switch';
import { useFormCustomerController } from './controller/form';
import { CustomerProfileModel } from '../../models/customerProfile';
import ConfirmDialog from '../../components/ConfirmDialog';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { IMAGE_CUSTOMER } from '../../lib/endpoints/customer';

interface Props {
  onClose: VoidFunction;
  selectedProfile: CustomerProfileModel;
  onSelectProfile: Function;
  onFetchCustomer: any;
}

const CustomerForm = ({ onClose, selectedProfile, onSelectProfile, onFetchCustomer }: Props) => {
  const controllers = useFormCustomerController({ selectedProfile, onSelectProfile, onClose, onFetchCustomer });
  const { t } = useTranslation('global');

  return (
    <Box>
      <IconButton onClick={() => { onClose(); controllers.handleReset() }} sx={{ mb: 2 }}>
        <KeyboardBackspaceIcon />
      </IconButton>
      <Typography variant="h4">{t('User Detail')}</Typography>
      <Grid container spacing={2} sx={{ mt: 1 }}>
        <Grid item xs={12} sm={4}>
          <Box
            sx={{
              p: 8,
              boxShadow:
                '0px 0px 2px rgba(145, 158, 171, 0.2), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)',
              borderRadius: '10px'
            }}
          >
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              {/* <label htmlFor="image-input"> */}
                <Avatar
                  alt=""
                  src={IMAGE_CUSTOMER + selectedProfile.profile?.image?.url}
                  style={{ width: 150, height: 150, objectFit: 'contain' }}
                />
              {/* </label> */}
              {/* <input type="file" id="image-input" style={{ display: 'none' }} /> */}
            </Box>
          </Box>
          <Box
            sx={{ display: 'flex', justifyContent: 'center', mt: 1, alignItems: 'center', gap: 2 }}
          >
            <Typography>
              <span style={{ color: 'green' }}>{t("customer_page.Active")}</span> / <span style={{ color: 'red' }}>{t("customer_page.InActive")}</span>
            </Typography>
            <SwitchComponent value={controllers.banUser} onChange={controllers.handleBanUser} />
          </Box>
        </Grid>
        <Grid item xs={12} sm={8}>
          <Box
            sx={{
              p: 4,
              boxShadow:
                '0px 0px 2px rgba(145, 158, 171, 0.2), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)',
              borderRadius: '10px'
            }}
          >
            <form>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <Typography>{t('customer_page.Full Name')}</Typography>
                  <TextField
                    fullWidth
                    margin='normal'
                    inputRef={controllers.fullName}
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography>{t('Email')}</Typography>
                  <TextField
                    fullWidth
                    margin='normal'
                    inputRef={controllers.email}
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography>{t('customer_page.Phone')}</Typography>
                  <TextField
                    fullWidth
                    margin='normal'
                    inputRef={controllers.phone}
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography>{t('Address')}</Typography>
                  <TextField
                    fullWidth
                    margin='normal'
                    inputRef={controllers.address}
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography>{t('customer_page.Date of Birth')}</Typography>
                  <TextField
                    fullWidth
                    margin='normal'
                    inputRef={controllers.dateOfBirth}
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography>{t("customer_page.Gender")}</Typography>
                  <TextField
                    fullWidth
                    margin='normal'
                    inputRef={controllers.gender}
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography>{t("customer_page.occupation")}</Typography>
                  <TextField
                    fullWidth
                    margin='normal'
                    inputRef={controllers.job}
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography>{t('Register via')}</Typography>
                  <TextField
                    fullWidth
                    margin='normal'
                    inputRef={controllers.register}
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                </Grid>
                {/* <Grid item xs={12} sm={6}>
                  <Typography>Level</Typography>
                  <TextField
                    fullWidth
                    margin='normal'
                    inputRef={controllers.level}
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                </Grid> */}
              </Grid>
            </form>
          </Box>
        </Grid>
      </Grid>
      <ConfirmDialog
        open={controllers.openConfirm}
        title={controllers.banUser ? t('customer_page.Do you want to ban this user ?') : t('customer_page.Do you want to unBan this user ?')}
        loading={controllers.loadingButton}
        onCancel={controllers.handleCloseConfirmForm}
        onConfirm={controllers.handleCredentialUser}
      />
    </Box>
  );
};
export default CustomerForm;
